/**
 * Tracks active play time, pausing when tab is hidden/blurred.
 */
export class GameTimer {
  constructor(savedState = null) {
    this.accumulatedTime = savedState?.accumulatedTime || 0;
    this.lastActiveTimestamp = null;
    this.isRunning = false;
  }

  start() {
    if (!this.isRunning) {
      this.lastActiveTimestamp = Date.now();
      this.isRunning = true;
    }
  }

  pause() {
    if (this.isRunning && this.lastActiveTimestamp !== null) {
      this.accumulatedTime += Date.now() - this.lastActiveTimestamp;
      this.lastActiveTimestamp = null;
      this.isRunning = false;
    }
  }

  getElapsedTime() {
    let total = this.accumulatedTime;
    if (this.isRunning && this.lastActiveTimestamp !== null) {
      total += Date.now() - this.lastActiveTimestamp;
    }
    return total;
  }

  getState() {
    const wasRunning = this.isRunning;
    if (wasRunning) {
      this.pause();
    }
    const state = { accumulatedTime: this.accumulatedTime };
    if (wasRunning) {
      this.start();
    }
    return state;
  }

  reset() {
    this.accumulatedTime = 0;
    this.lastActiveTimestamp = null;
    this.isRunning = false;
  }
}
